import React, { Component } from 'react';
import { Upload, Form, Input, Icon, Button, message } from 'antd';
import { connect } from 'react-redux';

import { uploadFile } from '../../../../actions';

import InputModal from './InputModal';

const FormItem = Form.Item;

const ProfileForm = Form.create({
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },

  mapPropsToFields(props) {
    return {
      newPassword: Form.createFormField({
        ...props.newPassword,
        value: props.newPassword.value,
      }),
      newFullname: Form.createFormField({
        ...props.newFullname,
        value: props.newFullname.value,
      }),
      newEmail: Form.createFormField({
        ...props.newEmail,
        value: props.newEmail.value,
      }),
      newDegree: Form.createFormField({
        ...props.newDegree,
        value: props.newDegree.value,
      }),
      newPhone: Form.createFormField({
        ...props.newPhone,
        value: props.newPhone.value,
      }),
      newAcademicRank: Form.createFormField({
        ...props.newAcademicRank,
        value: props.newAcademicRank.value,
      }),
      newResearchField: Form.createFormField({
        ...props.newResearchField,
        value: props.newResearchField.value,
      }),
      newMajor: Form.createFormField({
        ...props.newMajor,
        value: props.newMajor.value,
      }),
      newJournal: Form.createFormField({
        ...props.newJournal,
        value: props.newJournal.value,
      }),
      newTextbook: Form.createFormField({
        ...props.newTextbook,
        value: props.newTextbook.value,
      }),
      newProject: Form.createFormField({
        ...props.newProject,
        value: props.newProject.value,
      }),
      newWebsite: Form.createFormField({
        ...props.newWebsite,
        value: props.newWebsite.value,
      }),
      newAvatar: Form.createFormField({
        ...props.newAvatar,
        value: props.newAvatar.value,
      }),
      newAchievements: Form.createFormField({
        ...props.newAchievements,
        value: props.newAchievements.value,
      }),
    };
  },

  // onValuesChange(_, values) {
  //   console.log(values);
  // },
})(class extends Component {
  state = {
    passwordVisible: false,
    showJournalModal: false,
    showTextbookModal: false,
    showProjectModal: false,
    showAchievementsModal: false,
  };

  handleDeptChange = value => {
    this.props.onChange({ newDepartment: { value } });
  }

  passwordVisibilityChange = () => {
    this.setState({ passwordVisible: !this.state.passwordVisible });
  }

  beforeUpload = (file) => {
    const validImage = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!validImage) {
      message.error('Chỉ được tải lên định dạng JPG hoặc PNG!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('Kích thước ảnh phải nhỏ hơn 2MB!');
    }
    if (validImage && isLt2M) {
      this.props.uploadFile({ file, type: 'newAvatar', key: 'avatar' }, this.props.onChange);
    }
    return false;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err) => {
      if (!err) {
        this.props.showConfirmModal();
      }
    });
  }

  render() {
    const { form: { getFieldDecorator }, upload, userInfo, onChange } = this.props;
    const { passwordVisible, showJournalModal, showTextbookModal, showProjectModal, showAchievementsModal } = this.state;
    const passwordSuffix = <Icon type={passwordVisible ? 'eye-o' : 'eye'} onClick={this.passwordVisibilityChange} />;
    const avatar = userInfo.avatar || (upload.key === 'avatar' && upload.file && upload.file.location);

    return (
      <Form onSubmit={this.handleSubmit}>
        <FormItem
          {...this.props.formItemLayout}
          label="Mã GV"
        >
          <Input value={userInfo.lecturerId} disabled />
        </FormItem>
        <FormItem
          {...this.props.formItemLayout}
          label="Mật khẩu"
        >
          {getFieldDecorator('newPassword')(
            <Input
              placeholder="Để trống nếu không thay đổi"
              type={passwordVisible ? 'text' : 'password'}
              suffix={passwordSuffix}
              autoComplete="new-Password"
            />
          )}
        </FormItem>
        <FormItem
          {...this.props.formItemLayout}
          label="Họ và tên"
        >
          {getFieldDecorator('newFullname')(
            <Input
              placeholder="Họ và tên không được để trống"
            />
          )}
        </FormItem>
        <FormItem
          {...this.props.formItemLayout}
          label="Email"
        >
          {getFieldDecorator('newEmail')(
            <Input
              autoComplete="new-Email"
            />
          )}
        </FormItem>
        <FormItem
          {...this.props.formItemLayout}
          label="Số điện thoại"
        >
          {getFieldDecorator('newPhone')(
            <Input />
          )}
        </FormItem>
        {/* <FormItem
          {...this.props.formItemLayout}
          label="Học vị"
        >
          {getFieldDecorator('newDegree')(
            <Input placeholder="Cử nhân/Thạc sĩ/Tiến sĩ" />
          )}
        </FormItem>
        <FormItem
          {...this.props.formItemLayout}
          label="Học hàm"
        >
          {getFieldDecorator('newAcademicRank')(
            <Input placeholder="Phó giáo sư/Giáo sư" />
          )}
        </FormItem>
        <FormItem
          {...this.props.formItemLayout}
          label="Chuyên ngành"
        >
          {getFieldDecorator('newMajor')(
            <Input placeholder="Chuyên ngành" />
          )}
        </FormItem>
        <FormItem
          {...this.props.formItemLayout}
          label="Hướng nghiên cứu"
        >
          {getFieldDecorator('newResearchField')(
            <Input />
          )}
        </FormItem>
        <FormItem
          {...this.props.formItemLayout}
          label="Bài báo khoa học"
        >
          <Button onClick={() => this.setState({ showJournalModal: true })}>
            <Icon type="edit" /> Chỉnh sửa
          </Button>
          <InputModal
            type='journal'
            visible={showJournalModal}
            onCancel={() => {
              this.setState({ showJournalModal: false });
              onChange({ newJournal: { value: userInfo.journal } });
            }}
            onSubmit={value => {
              this.setState({ showJournalModal: false });
              onChange({ newJournal: { value } });
            }}
            content={userInfo.journal}
            onChange={({ data }) => onChange({ newJournal: { value: data } })}
          />
        </FormItem>
        <FormItem
          {...this.props.formItemLayout}
          label="Giáo trình"
        >
          <Button onClick={() => this.setState({ showTextbookModal: true })}>
            <Icon type="edit" /> Chỉnh sửa
          </Button>
          <InputModal
            type='textbook'
            visible={showTextbookModal}
            onCancel={() => {
              this.setState({ showTextbookModal: false });
              onChange({ newTextbook: { value: userInfo.textbook } });
            }}
            onSubmit={value => {
              this.setState({ showTextbookModal: false });
              onChange({ newTextbook: { value } });
            }}
            content={userInfo.textbook}
            onChange={({ data }) => onChange({ newTextbook: { value: data } })}
          />
        </FormItem>
        <FormItem
          {...this.props.formItemLayout}
          label="Đề tài"
        >
          <Button onClick={() => this.setState({ showProjectModal: true })}>
            <Icon type="edit" /> Chỉnh sửa
          </Button>
          <InputModal
            type='project'
            visible={showProjectModal}
            onCancel={() => {
              this.setState({ showProjectModal: false });
              onChange({ newProject: { value: userInfo.project } });
            }}
            onSubmit={value => {
              this.setState({ showProjectModal: false });
              onChange({ newProject: { value } });
            }}
            content={userInfo.project}
            onChange={({ data }) => onChange({ newProject: { value: data } })}
          />
        </FormItem>
        <FormItem
          {...this.props.formItemLayout}
          label="Thành tích"
        >
          <Button onClick={() => this.setState({ showAchievementsModal: true })}>
            <Icon type="edit" /> Chỉnh sửa
          </Button>
          <InputModal
            type='achievements'
            visible={showAchievementsModal}
            onCancel={() => {
              this.setState({ showAchievementsModal: false });
              onChange({ newAchievements: { value: userInfo.achievements } });
            }}
            onSubmit={value => {
              this.setState({ showAchievementsModal: false });
              onChange({ newAchievements: { value } });
            }}
            content={userInfo.achievements}
            onChange={({ data }) => onChange({ newAchievements: { value: data } })}
          />
        </FormItem>
        <FormItem
          {...this.props.formItemLayout}
          label="Website / Blog"
        >
          {getFieldDecorator('newWebsite')(
            <Input />
          )}
        </FormItem>
        <FormItem
          {...this.props.formItemLayout}
          label="Ảnh đại diện"
        >
          <Upload
            name="avatar"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            beforeUpload={this.beforeUpload}
          >
            {avatar
              ? <img style={{ width: 128, height: 128, objectFit: 'cover' }} src={avatar} alt="avatar" />
              : <div>
                <Icon type={upload.loading ? 'loading' : 'plus'} />
                <div className="ant-upload-text">Tải lên</div>
              </div>}
          </Upload>
        </FormItem> */}
        <FormItem style={{ textAlign: 'center' }}>
          <Button type="primary" htmlType="submit" disabled={!this.props.isValid}><Icon type='edit' />Thay đổi thông tin</Button>
        </FormItem>
      </Form>
    );
  }
});

const mapStateToProps = state => ({
  userInfo: state.user.info,
  upload: state.upload,
});

const mapDispatchToProps = {
  uploadFile,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileForm);



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/Profile/ProfileForm.js